export const LOCATION = {
  ALL: '',
  LEFT_RIGHT: '',
  TOP_BOTTOM: '',
  TOP: '',
  RIGHT: '',
  BOTTOM: '',
  LEFT: '',
} as const;
